// Models
// Translations
import { Strings } from "@ms/uno-resources/lib/local/CultureUtilities";
/** Get localized label placeholder strings (evaluated at runtime for proper localization) */ export function getLabelPlaceholders() {
    return [
        Strings.Labels_PinkLabelPlaceholderText,
        Strings.Labels_RedLabelPlaceholderText,
        Strings.Labels_YellowLabelPlaceholderText,
        Strings.Labels_GreenLabelPlaceholderText,
        Strings.Labels_BlueLabelPlaceholderText,
        Strings.Labels_PurpleLabelPlaceholderText,
        Strings.Labels_BronzeLabelPlaceholderText,
        Strings.Labels_LimeLabelPlaceholderText,
        Strings.Labels_AquaLabelPlaceholderText,
        Strings.Labels_GrayLabelPlaceholderText,
        Strings.Labels_SilverLabelPlaceholderText,
        Strings.Labels_BrownLabelPlaceholderText,
        Strings.Labels_CranberryLabelPlaceholderText,
        Strings.Labels_OrangeLabelPlaceholderText,
        Strings.Labels_PeachLabelPlaceholderText,
        Strings.Labels_MarigoldLabelPlaceholderText,
        Strings.Labels_LightGreenLabelPlaceholderText,
        Strings.Labels_DarkGreenLabelPlaceholderText,
        Strings.Labels_TealLabelPlaceholderText,
        Strings.Labels_LightBlueLabelPlaceholderText,
        Strings.Labels_DarkBlueLabelPlaceholderText,
        Strings.Labels_LavenderLabelPlaceholderText,
        Strings.Labels_PlumLabelPlaceholderText,
        Strings.Labels_LightGrayLabelPlaceholderText,
        Strings.Labels_DarkGrayLabelPlaceholderText
    ];
}
/**
 * Get the color placeholder string for a label by index
 * @param labelIndex Label index number (0-based)
 * @returns The placeholder text for the label (e.g., "Pink", "Red", "Yellow"), or empty string if index is out of range
 */ export function getLabelPlaceholderByIndex(labelIndex) {
    const labelPlaceholders = getLabelPlaceholders();
    if (labelIndex < 0 || labelIndex >= labelPlaceholders.length) {
        return "";
    }
    return labelPlaceholders[labelIndex];
}
/**
 * Get text to show in UI for the given label. If label name is empty or null, return the default string.
 * @param label the label to get display text for
 */ export function getLabelPlaceholder(label) {
    if (label.name == null || label.name === "") {
        return label.placeholderText;
    }
    return label.name;
}
